import {apiFetch} from './api.js'
import urlBase64ToUint8Array from "../scripts/urlBase64ToUint8Array.js"

const publicKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;


export const saveSubscription = async (sub, user_id) => {
    const endPoint = process.env.REACT_APP_URL_SUBSCRIBE
    const response = await apiFetch(endPoint, {
        method: 'POST',
        body: JSON.stringify({ user_id, subscription: sub })
    })

    if (!response.ok) {
        const err = await response.json()
        throw new Error(err.message || 'Error al guardar suscripción')
    }

    return await response.json()
}

export const subscribe = async (user_id) => {
    if (!user_id) return

    const permission = await Notification.requestPermission()
    if (permission !== 'granted') return

    const reg = await navigator.serviceWorker.register('/sw.js')
    await navigator.serviceWorker.ready

    const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey)
    })

    await saveSubscription(sub, user_id)
}

export const autoSubscribe = async (user_id) => {
    const reg = await navigator.serviceWorker.getRegistration()
    if (!reg) return false

    const sub = await reg.pushManager.getSubscription()
    if (!sub) return false

    await saveSubscription(sub, user_id)
    return true
}

export const unsubscribe = async () => {
    const endPoint = process.env.REACT_APP_URL_UNSUBSCRIBE

    const reg = await navigator.serviceWorker.getRegistration()

    if (reg) {
        const sub = await reg.pushManager.getSubscription()
        if (sub) await sub.unsubscribe()
    }

    const response = await apiFetch(endPoint, {
        method: 'POST',
        credentials: 'include'
    })

    const data = await response.json()

    if(!data){
        throw new Error("Error al dessuscribirte")
    }

    return data
}

export const sendNotification = async (userId, title, body, url, teamId) =>{
    const endPoint = process.env.REACT_APP_URL_SEND_NOTIFICATION

    try{
        const response = await apiFetch(endPoint, {
            method: 'POST',
            body: JSON.stringify({ userId, title, body, url, teamId })
        })

        const data = await response.json()

        if(!data){
            throw new Error("Error al mandar la notificacion")
        }

        return data
    }catch(err){
        return err.message
    }
}

export const ShowNotificationsByUserId = async (sendNotifications) => {
    const endPoint = process.env.REACT_APP_URL_MY_NOTIFICATIONS
        
    try{
        const response = await apiFetch(endPoint, {
            method: 'POST',
            body: JSON.stringify({ sendNotifications })
        })

        if(!response.ok) return {status: false}

        const data = await response.json()

        return data

    }catch(err){
        return err.message
    }
}

export const ShowNotificationByID = async(id, sendNotification) => {
    const endPoint = process.env.REACT_APP_URL_MY_NOTIFICATION

    try{
        const response = await apiFetch(`${endPoint}/${id}`)

        if(!response.ok) return {status: false}

        const data = await response.json()
        console.log('data:', data)

        return data
    }catch(err){
        return err.message
    }
}